import { useTranslation } from "react-i18next";
import OptionLabel from "../../../ui/forms/OptionLabel";
import { withInclusion, type AcceptedChoice } from "../datasets/acceptedResults";

/**
 * The accepted results a release holds (K-5): the newest accepted revision of each lineage
 * is picked by default, so opening the dialog never publishes old and corrected values
 * together (M3-9-C14); an older revision may be picked instead.
 */
export default function AcceptedResultsPicker({
  choices,
  overrides,
  onChange,
}: {
  choices: readonly AcceptedChoice[];
  overrides: ReadonlyMap<string, boolean>;
  onChange: (overrides: ReadonlyMap<string, boolean>) => void;
}) {
  const { t } = useTranslation();
  if (choices.length === 0) {
    return <p className="app-text-muted text-sm">{t("data.dataset.noAccepted")}</p>;
  }
  return (
    <div className="space-y-2">
      <p className="app-text-muted text-xs">{t("data.dataset.oneRevision")}</p>
      <ul className="max-h-64 space-y-1 overflow-y-auto text-sm">
        {choices.map((choice) => (
          <li key={choice.source}>
            <OptionLabel align="start">
              <input
                type="checkbox"
                checked={overrides.get(choice.source) ?? choice.defaultIncluded}
                onChange={(event) => { onChange(withInclusion(choices, overrides, choice, event.target.checked)); }}
              />
              <span>
                {t("data.index.statements", { count: choice.statements })}
                <span className="app-text-muted block break-all font-mono text-xs">{choice.source}</span>
                {choice.replaces.length > 0 ? <span className="app-text-muted block text-xs">{t("data.dataset.replaces", { sources: choice.replaces.join(", ") })}</span> : null}
                {!choice.defaultIncluded ? <span className="app-text-muted block text-xs">{t("data.dataset.earlierRevision")}</span> : null}
              </span>
            </OptionLabel>
          </li>
        ))}
      </ul>
    </div>
  );
}
